/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_NoneInputs */

const en_us2_onboarding_equipment_none = /** @type {(inputs: Onboarding_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just my body weight`)
};

const pt_br2_onboarding_equipment_none = /** @type {(inputs: Onboarding_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só o peso do corpo`)
};

const es_419_onboarding_equipment_none = /** @type {(inputs: Onboarding_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo mi peso corporal`)
};

const pt_pt2_onboarding_equipment_none = /** @type {(inputs: Onboarding_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só o peso do corpo`)
};

const fr_fr2_onboarding_equipment_none = /** @type {(inputs: Onboarding_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste mon poids du corps`)
};

const de_de2_onboarding_equipment_none = /** @type {(inputs: Onboarding_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur mein Körpergewicht`)
};

const it_it2_onboarding_equipment_none = /** @type {(inputs: Onboarding_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo il mio peso corporeo`)
};

/**
* | output |
* | --- |
* | "Just my body weight" |
*
* @param {Onboarding_Equipment_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_none = /** @type {((inputs?: Onboarding_Equipment_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_none(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_none(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_none(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_none(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_none(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_none(inputs)
	return en_us2_onboarding_equipment_none(inputs)
});
export { onboarding_equipment_none as "onboarding.equipment.none" }